angular.module('bribac.components.scheduleDetails', [
  'bribac.translations'
])

  .component('scheduleDetails', {
    templateUrl: 'schedule-details-component.html',
    controller: 'ScheduleDetailsComponentCtrl',
    bindings: {
      schedule: '<'
    }
  })

  .controller('ScheduleDetailsComponentCtrl', function(
    $translate,
    $filter
  ) {
    var $ctrl = this

    var weekdays = 'MON TUE WED THU FRI SAT SUN'.split(' ')

    function translate(weekdayKey) {
      return $translate.instant('weekdays.' + weekdayKey + '.short')
    }

    $ctrl.dateFilterFix = function(time) {
      // A full date+time must be used for the Angular date filter to recognize the input.
      // We will only show the time to the user so we can use any date.
      return '2001-01-01T' + time
    }

    $ctrl.$onChanges = function() {
      $ctrl.randoMoodQuestionString = $ctrl.schedule.moodQuestion.join(', ')

      $ctrl.formattedWeekdays = $ctrl.schedule.weekdays
        .sort(function(a, b) {return weekdays.indexOf(a) - weekdays.indexOf(b)})
        .reduce(function(str, currValue, index, values) {
          if (!str) return translate(currValue)

          var prevValue = values[index - 1]
          var nextValue = values[index + 1]

          var currPos = weekdays.indexOf(currValue)
          var prevPos = weekdays.indexOf(prevValue)
          var nextPos = weekdays.indexOf(nextValue)

          if (currPos === prevPos + 1) {
            if (str.slice(-3) !== ' - ') str += ' - '
            if (currPos !== nextPos - 1) str += translate(currValue)
          } else {
            str += ', ' + translate(currValue)
          }

          return str
        }, '')
    }

    $ctrl.haveFixedTests = function() {
      return !$ctrl.schedule.fixedTimes && $ctrl.schedule.fixedTimes.length > 0
    }

  })
